module.exports = __webpack_public_path__ + "static/media/team4.47647e4b.jpg";